import buttonAlignmentModalLight from "../../../../src/images/snippets/button-alignment-modal-light.png";
import buttonAlignmentModalDark from "../../../../src/images/snippets/button-alignment-modal-dark.png";
import buttonAlignmentPageLight from "../../../../src/images/snippets/button-alignment-page-light.png";
import buttonAlignmentPageDark from "../../../../src/images/snippets/button-alignment-page-dark.png";
import * as React from 'react';
export default {
  buttonAlignmentModalLight,
  buttonAlignmentModalDark,
  buttonAlignmentPageLight,
  buttonAlignmentPageDark,
  React
};